import React, { BaseSyntheticEvent, FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import Spinner from '../spinner/Spinner';

import './button.scss';

type Props = {
  asText?: boolean;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  href?: string;
  loading?: boolean;
  onClick?: (event?: BaseSyntheticEvent) => void;
  theme?: 'neutral' | 'primary' | 'negative';
  type?: 'button' | 'submit' | 'reset';
};

const Button: FC<Props> = ({
  asText,
  children,
  className = '',
  disabled,
  href,
  loading,
  onClick = () => {},
  theme = 'neutral',
  type = 'button',
}) => {
  const cssClasses = classnames(asText ? 'as-text' : 'button', className, theme, { disabled, loading });

  function renderSpinner() {
    if (!loading) return null;
    return (
      <div className="spinner-wrapper">
        <Spinner theme={asText ? 'normal' : 'inversed'} />
      </div>
    );
  }

  if (href) {
    return (
      <Link className={cssClasses} to={href}>
        {children}
        {renderSpinner()}
      </Link>
    );
  }
  return (
    <button className={cssClasses} disabled={disabled} onClick={onClick || (() => {})} type={type}>
      {children}
      {renderSpinner()}
    </button>
  );
};

export default Button;
